import { render, staticRenderFns } from "./TopEntityComponentSite.vue?vue&type=template&id=49aab174&"
import script from "./TopEntityComponentSite.vue?vue&type=script&lang=js&"
export * from "./TopEntityComponentSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkSite: require('/srv/rir-platform/tourism/src/tourism-front/components/common/LinkSite/index.vue').default})
